import React from 'react';
import Checkbox from '../Checkbox';
import dynamicallyResizeShopifyImageUrl from '@jbhi-fi/utils/src/resizeShopifyImage/resizeShopifyImage';
import { AlgoliaProductHit } from '../../utils/types';
import IconPlusCrazy from '../../../assets/svg/icon-plus-crazy.svg';
import { submitTracking } from '@jbhi-fi/components/src/Tracking/utils/shopifyActionTrackingHelper';
import { trackProductClick } from '@jbhi-fi/utils/src/ga4Tracking/functions/trackProductClick';
import { transformAlgoliaHitForTracking } from '@jbhi-fi/components/src/Algolia/transformers/transformAlgoliaHitForTracking';
import { TrackingDescriptorType } from '@jbhi-fi/components/src/Tracking/types';
import { getStoreCurrency } from '../../utils/shopify/getStoreCurrency';
import { styles } from './BundleItem.css';

export type BundleItemProps = {
  isChecked: boolean;
  onCheck: (sku: string, checked: boolean) => void;
  product: AlgoliaProductHit;
  index: any;
  shouldShowPrice?: boolean;
  trackingDescriptor?: TrackingDescriptorType;
  shouldShowCheckbox?: boolean;
};

const BundleItem = ({
  isChecked,
  onCheck,
  product,
  index,
  shouldShowPrice = false,
  shouldShowCheckbox = false,
  trackingDescriptor,
}: BundleItemProps) => {
  const { sku, handle, title } = product;
  const dollars = Math.trunc(Number(product.price));
  const cents = Math.round(product.price * 100 - dollars * 100);
  const imageUrl = dynamicallyResizeShopifyImageUrl(product.product_image, '300x300');

  const handleClick = () => {
    if (trackingDescriptor) {
      submitTracking({
        event: 'productClick',
        trackingDescriptor,
        gtm: product.google_tag_manager,
      });
    }
    trackProductClick({
      location: 'pdp',
      currency: getStoreCurrency(),
      clickedProduct: transformAlgoliaHitForTracking(
        product,
        trackingDescriptor?.ecommerceExtraProps?.list?.toString()
      ),
    });
  };

  return (
    <>
      {index !== 0 && (
        <div className={styles.productBundleItemDivider}>
          <IconPlusCrazy viewBox="0 0 15 16" />
        </div>
      )}
      <div className={styles.productBundleItem}>
        <a href={`/products/${handle}`} className={styles.image} onClick={handleClick}>
          {'loading' in HTMLImageElement.prototype ? (
            <img
              src={imageUrl}
              loading="lazy"
              alt={title}
              width="300"
              height="300"
              style={{
                opacity: 1,
                visibility: 'visible',
              }}
            />
          ) : (
            <img data-src={imageUrl} width="300" height="300" alt={title} className="lazyload" />
          )}
        </a>
        <div className={styles.content}>
          <div className={styles.title}>
            <a onClick={handleClick} href={`/products/${handle}`}>
              {title}
            </a>
          </div>
          {shouldShowPrice ? (
            <div className={styles.price}>
              ${dollars}
              {cents > 0 ? `.${cents < 10 ? `0${cents}` : cents}` : ''}
            </div>
          ) : null}
        </div>
        {shouldShowCheckbox ? (
          <div className={styles.checkboxWrapper}>
            <Checkbox
              id={sku}
              name={sku}
              isChecked={isChecked}
              onChange={event => onCheck(sku, event.target.checked)}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default BundleItem;
